/** Units of Measure for Material */
export class UnitsOfMeasure {
  public constructor(
    /** Generated unique ID, not related to the Units of Measure */
    public id: string,
    public materialNumber: string,
    public altUnit: string,
    public length: number,
    public width: number,
    public height: number,
    public unitOfDimension: string,
    public volume: number,
    public volumeUnit: string,
    public grossWeight: number,
    public weightUnit: string
  ) {}
}
